import React, { useId } from 'react';

export function EndingSoonIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  const clipId = useId();
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M10 19C14.1421 19 17.5 15.6421 17.5 11.5C17.5 7.35786 14.1421 4 10 4C5.85786 4 2.5 7.35786 2.5 11.5C2.5 15.6421 5.85786 19 10 19Z'
          stroke='currentColor'
          strokeWidth='2.14286'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10 19C14.1421 19 17.5 15.6421 17.5 11.5C17.5 7.35786 14.1421 4 10 4C5.85786 4 2.5 7.35786 2.5 11.5C2.5 15.6421 5.85786 19 10 19Z'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2.14286'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M10 11.5L13 14' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M10 11.5L13 14'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M6 1H14' stroke='currentColor' strokeWidth='2' strokeLinejoin='round' />
        <path d='M6 1H14' stroke='currentColor' strokeOpacity='0.2' strokeWidth='2' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
